import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Dataset } from 'src/app/models/dataset.model';
import { DatasetsService } from 'src/app/services/datasets.service';
import * as globals from '../../globals';
import { ErrorHandlerService } from '@aveva/connect-web-core';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-add-dataset',
  templateUrl: './add-dataset.component.html',
  styleUrls: ['./add-dataset.component.scss']
})
export class AddDatasetComponent {

  constructor(
    private errorHandler: ErrorHandlerService,
    private datasetsService: DatasetsService,
    private snackBar: MatSnackBar,
    private logger: LoggingService) { }

  selectFile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file: File = event.target.files[0];
      this.currentFile = file;
      if (this.dataset?.id !== undefined) {
        this.dataset.file = file?.name;
      }
      this.isFileUpload = true;
    }
  }

  create() {
    this.loadingSpinner.emit(true);
    
    if (this.submitting) {
      return;
    }

    this.submitting = true;

    try {
      if ((this.dataset?.file === undefined || this.dataset?.file === '') && (this.currentFile?.name === undefined || this.currentFile?.name === '')) {
        this.displaySnackBar(globals.datasetFile_required);
        this.loadingSpinner.emit(false);
        return;
      }

      const datasetData = (this.dataset.id !== undefined) ? 
      this.dataset : { 
        id: 0, 
        name: this.dataset?.name, 
        description: this.dataset.description, 
        file: this.currentFile?.name,
        backfill_days: this.dataset?.backfill_days
      };

      this.datasetsService.addOrUpdate(datasetData).subscribe({
        next: (data) => {
          if(data) {

            if(this.isFileUpload) {

              const formData = new FormData();
              formData.append('file', this.currentFile);

              this.datasetsService.dataset_upload(formData).subscribe({
                next: (result) => {
                  if (result) {
                    this.logger.logEvent('Dataset File Upload Success', {fileName: this.currentFile?.name, datasetName: this.dataset?.name});
                    this.form.resetForm();
                    this.loadingSpinner.emit(false);
                    this.displaySnackBar(this.dataset?.id === undefined ? globals.datasetAdd_success : globals.datasetUpdate_success);
                    this.saved.emit(data);
                  }
                  else {
                    this.loadingSpinner.emit(false);
                    this.displaySnackBar(this.dataset?.id === undefined ? globals.datasetAdd_fail : globals.datasetUpdate_fail);
                  }
                },
                error: (e) => {
                  this.logger.logException(e);
                  this.loadingSpinner.emit(false);
                  this.displaySnackBar(this.dataset?.id === undefined ? globals.datasetAdd_fail : globals.datasetUpdate_fail);                
                }
              });
            }
            else {
              this.form.resetForm();
              this.loadingSpinner.emit(false);
              this.displaySnackBar(this.dataset?.id === undefined ? globals.datasetAdd_success : globals.datasetUpdate_success);
              this.saved.emit(data);
            }
          }
        },
        error: (e) => {
          this.logger.logException(e);
          this.loadingSpinner.emit(false);
          this.displaySnackBar(this.dataset?.id === undefined ? globals.datasetAdd_fail : globals.datasetUpdate_fail);
        }
      });

    } catch (error) {
      this.logger.logException(error);
      if (error.status === 409) {
        this.form.controls['name'].setErrors({ 'notUnique': true });
      } else if (error.error?.statusCode === 400 && error.error?.errorCode === globals.RESOURCELIMIT) {
        this.errorHandler.handle(error.error, 'datasetLimitReached');
      } else {
        return this.errorHandler.handle(error);
      }
    }
    finally {
      this.submitting = false;
      this.fileSelecter.nativeElement.value = '';
    }
  }  

  cancel = () => this.reset();

  close = () => this.reset();

  private reset = () => {
    this.cancelled.emit();
    this.fileSelecter.nativeElement.value = '';
  };
  
  displaySnackBar = (message: string) => this.snackBar.open(message, null, {duration: 3000});

  submitting = false;
  currentFile: File;
  isFileUpload: boolean;

  @Input() dataset: Dataset = new Dataset();
  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();
  @Output() loadingSpinner: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('form', { static: true }) form: NgForm;
  @ViewChild('fileSelecter') fileSelecter: ElementRef;

  @HostListener('window:beforeunload')
  canDeactivate = (): boolean => !this.form.dirty || this.form.submitted;

}
